import React from 'react';
// import CloseCircleIcon from "../icons/CloseCircleIcon";
import './ErrorCard.css';

const ErrorCard = ({ title, description }) => {
  return (
    <div className='error-card'>
      <div className='col-12'>
        <div className='row'>
          {/* <div className="col-auto my-auto">
            <CloseCircleIcon size={24} color="#000" fillColor="#F44336" />
          </div> */}
          <div className='col pl-0'>
            <div className='error-title'>{title}</div>
            <p className='error-text'>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorCard;
